import { render, staticRenderFns } from "./AddExhibitionForm.vue?vue&type=template&id=3229683e&scoped=true&"
import script from "./AddExhibitionForm.vue?vue&type=script&lang=ts&"
export * from "./AddExhibitionForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddExhibitionForm.vue?vue&type=style&index=0&id=3229683e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3229683e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
